import type { AppConfig } from '@empathyco/playboard-core/dist/src'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import {
  ACCOUNT_ROUTES,
  AUDIT_ROUTES,
  BEACON_NEXT_QUERIES_ROUTES,
  BEACON_RELATED_TAGS_ROUTES,
  BLACKLIST_ROUTES,
  CONFIGURATIONS_ROUTES,
  createNavigationGuard,
  Domain,
  EXPLAIN_ROUTES,
  FACETS_ROUTES,
  GUARDS_EXECUTOR,
  HIGHLIGHTS_ROUTES,
  Home,
  INDEX_ROUTES,
  INSIGHTS_ROUTES,
  INSTANCE_MANAGEMENT_ROUTES,
  LoginGuard,
  LogoutGuard,
  PageNotFound,
  PlatformLogin,
  PROMOTIONS_ROUTES,
  REDIRECTIONS_ROUTES,
  RELATED_PROMPTS_ROUTES,
  Root,
  ROUTER_CONSTS,
  SEARCH_EQUALIZE_ROUTES,
  SEARCH_QUERY_RANKING_ROUTES,
  SYNONYMS_ROUTES,
  USER_ROLE_MANAGEMENT_ROUTES,
} from '@empathyco/playboard-core/dist/src'
import Router from 'vue-router'

export function getRouter({ externalRoutes }: AppConfig): Router {
  const { VUE_APP_PREVIEW_PATH } = process.env

  const router = new Router({
    base: VUE_APP_PREVIEW_PATH,
    mode: VUE_APP_PREVIEW_PATH ? 'hash' : 'history',
    routes: [
      {
        name: ROUTER_CONSTS.routes.login,
        path: '/login',
        component: PlatformLogin,
        beforeEnter: GUARDS_EXECUTOR([LoginGuard.execute]),
      },
      {
        name: ROUTER_CONSTS.routes.logout,
        path: '/logout',
        beforeEnter: GUARDS_EXECUTOR([LogoutGuard.execute]),
      },
      {
        name: ROUTER_CONSTS.routes.root,
        path: '/',
        component: Root,
        children: [
          ...INDEX_ROUTES,
          ...USER_ROLE_MANAGEMENT_ROUTES,
          ...ACCOUNT_ROUTES,
          {
            name: ROUTER_CONSTS.routes.home,
            path: `/:${ROUTER_CONSTS.params.instanceId}?`,
            component: Home,
            // FYI: route guards moved to component
            children: [
              ...HIGHLIGHTS_ROUTES,
              ...AUDIT_ROUTES,
              ...INSTANCE_MANAGEMENT_ROUTES,
              {
                name: ROUTER_CONSTS.routes[DomainEnum.SEARCH],
                path: DomainEnum.SEARCH,
                component: Domain,
                meta: {
                  domain: DomainEnum.SEARCH,
                },
                children: [
                  ...INSIGHTS_ROUTES[DomainEnum.SEARCH],
                  ...SEARCH_EQUALIZE_ROUTES,
                  ...SYNONYMS_ROUTES,
                  ...BLACKLIST_ROUTES,
                  ...PROMOTIONS_ROUTES,
                  ...REDIRECTIONS_ROUTES,
                  ...SEARCH_QUERY_RANKING_ROUTES,
                  ...RELATED_PROMPTS_ROUTES,
                  ...FACETS_ROUTES,
                  ...BEACON_RELATED_TAGS_ROUTES,
                  ...BEACON_NEXT_QUERIES_ROUTES,
                  ...EXPLAIN_ROUTES,
                ],
              },
              {
                name: ROUTER_CONSTS.routes[DomainEnum.BROWSE],
                path: DomainEnum.BROWSE,
                component: Domain,
                meta: {
                  domain: DomainEnum.BROWSE,
                },
                children: [
                  ...INSIGHTS_ROUTES[DomainEnum.BROWSE],
                  ...CONFIGURATIONS_ROUTES[DomainEnum.BROWSE],
                ],
              },
            ],
          },
        ],
      },
      {
        name: ROUTER_CONSTS.routes.pageNotFound,
        path: '*',
        component: PageNotFound,
      },
    ],
  })

  if (externalRoutes?.length) {
    router.beforeEach(createNavigationGuard(externalRoutes))
  }

  return router
}
